import ContentBox from 'components/ContentBox';
import HomeScreenCategories from 'components/HomeScreenCategories';
import LocationSelector from 'components/LocationSelector';
import NavButton from 'components/NavButton';
import PreviousOrdersItems from 'components/PreviousOrdersItems';
import {UserContext} from 'contexts/UserContext';
import {useContext, useEffect} from 'react';
import StartNavElements from 'components/StartNavElements';
import {AppParamsContext} from 'contexts/AppParamsContext';
import WelcomeScreenV2 from 'views/Welcome/WelcomeScreenV2';

export default function Welcome() {
  const {appParams} = useContext(AppParamsContext);
  const {userData} = useContext(UserContext);

  useEffect(() => {
    if (userData?.email) {
      let dataToSendToWebView = {
        type: 'userUUID',
        data: userData.uuid,
      };
      let emailDataToSendToWebView = {
        type: 'email',
        data: userData.email,
      };

      window.ReactNativeWebView?.postMessage(JSON.stringify(emailDataToSendToWebView));
      window.ReactNativeWebView?.postMessage(JSON.stringify(dataToSendToWebView));
    }
  }, [userData]);
  return (
    <div className={`welcome-root h-full overflow-auto pb-36`}>
      {appParams?.order?.welcomeLocationSelector && <LocationSelector />}
      {(appParams?.homeScreen?.elements || [])?.length === 0 && appParams?.styles?.homePage?.showContentBox && (
        <div className='my-2'>
          <ContentBox place='welcome_page' />
        </div>
      )}
      {(appParams?.homeScreen?.elements || [])?.length === 0 &&
        (appParams?.navigation?.startNavSettings?.enabled == null || appParams?.navigation?.startNavSettings?.enabled === false) &&
        (appParams?.navigation?.startNavElements || [])?.length > 0 && (
          <div className='nav-buttons-container'>
            {(appParams?.navigation?.startNavElements || []).map((element, index) => (
              <NavButton
                key={index}
                element={element}
                svgName={element?.icon}
                path={element?.path}
                text={element?.transCode}
                text2={element?.transCode2}
                multiLangText={element?.multiLang}
                multiLangText2={element?.multiLang2}
                className={element?.className}
                module={element?.module}
                customColor={element?.customColor}
              />
            ))}
          </div>
        )}
      {(appParams?.homeScreen?.elements || [])?.length === 0 && appParams?.navigation?.startNavSettings?.enabled && <StartNavElements />}
      {(appParams?.homeScreen?.elements || [])?.length === 0 && <div>{appParams?.styles?.homePage?.showCategories && <HomeScreenCategories />}</div>}
      {(appParams?.homeScreen?.elements || [])?.length === 0 && <div>{appParams?.styles?.homePage?.showPreviousOrders && <PreviousOrdersItems />}</div>}
      {(appParams?.homeScreen?.elements || [])?.length > 0 && <WelcomeScreenV2 />}
    </div>
  );
}
